import * as React from 'react'

function SvgBriefcaseIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.188 5.063H2.813a.563.563 0 00-.562.562v9c0 .31.252.563.562.563h12.375c.311 0 .563-.252.563-.563v-9a.563.563 0 00-.563-.563z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.813 5.063V3.938a1.125 1.125 0 00-1.126-1.126H7.313a1.125 1.125 0 00-1.125 1.126v1.124M15.751 8.881a13.438 13.438 0 01-6.75 1.806c-2.37.004-4.699-.619-6.75-1.805M8.156 8.438h1.688"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgBriefcaseIcon
